export default "__VITE_ASSET__e879d251__"